// Module
var code = `<button type="button" class="hi-btn" aria-label="Help">?</button>
`;
// Exports
export default code;